import React from 'react';
import { ChatWindow } from '../components/chat/ChatWindow';
import { Chat } from '../types/chat';

interface ChatPageProps {
  chat: Chat;
  onBack: () => void;
}

export const ChatPage: React.FC<ChatPageProps> = ({ chat, onBack }) => {
  return (
    <div className='h-screen'>
      <ChatWindow chat={chat} onBack={onBack} />
    </div>
  );
};
